import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-2" }

import { FormInput, FormLabel, FormSelect, FormSwitch } from "@easy/ui/forms";
import { BlockDefinitionLinkField } from "@/apps/page/services/blocks/block.interfaces";
import { ref, ComputedRef, computed } from "vue";
import { useGetters } from "@/store/vuex-composition-mappers";
import { useI18n } from "vue-i18n";

enum LinkType {
    CUSTOM = "custom",
    TO_SECTION = "to-section",
}

interface SectionWebIdLink {
    label: string;
    value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkField',
  props: {
    field: {},
    item: {}
  },
  setup(__props: any) {



const { t } = useI18n();

const linkTypes = computed(() => [
    { label: t("page.block.fields.linkTypeCustom"), value: LinkType.CUSTOM },
    { label: t("page.block.fields.linkTypeToSection"), value: LinkType.TO_SECTION },
]);

const selectedLinkType = ref(
    __props.item[__props.field.value] && __props.item[__props.field.value].startsWith("#") && __props.item[__props.field.value].length > 1
        ? LinkType.TO_SECTION
        : LinkType.CUSTOM
);

const { sectionWebIdLinks } = useGetters("page", ["sectionWebIdLinks"]) as {
    sectionWebIdLinks: ComputedRef<SectionWebIdLink[]>;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(FormLabel), null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.field.label), 1)
      ]),
      _: 1
    }),
    _createVNode(_unref(FormSwitch), {
      modelValue: selectedLinkType.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLinkType).value = $event)),
      options: linkTypes.value
    }, null, 8, ["modelValue", "options"]),
    (selectedLinkType.value === LinkType.CUSTOM)
      ? (_openBlock(), _createBlock(_unref(FormInput), {
          key: 0,
          id: _ctx.field.value,
          title: "",
          modelValue: _ctx.item[_ctx.field.value],
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item[_ctx.field.value]) = $event))
        }, null, 8, ["id", "modelValue"]))
      : _createCommentVNode("", true),
    (selectedLinkType.value === LinkType.TO_SECTION)
      ? (_openBlock(), _createBlock(_unref(FormSelect), {
          key: 1,
          modelValue: _ctx.item[_ctx.field.value],
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item[_ctx.field.value]) = $event)),
          label: "",
          options: _unref(sectionWebIdLinks),
          value: _ctx.item[_ctx.field.value]
        }, null, 8, ["modelValue", "options", "value"]))
      : _createCommentVNode("", true)
  ]))
}
}

})